(() => {
  const SCROLL_DELAY = 700;
  const TARGET_RETRY_INTERVAL = 100;
  const TARGET_RETRY_TIMEOUT = 5000;
  const RATING_SNIPPET_SELECTOR = '.ruk_rating_snippet';
  const REVIEWS_IO_WIDGET_SELECTOR = '#ReviewsWidget, reviewsio-product-reviews-widget, [data-reviewsio-widget="polaris"], .reviews-io-polaris-widget';
  const PDP_REVIEWS_SELECTOR = '#pdp-reviews__container';
  const parseBoolean = (value) => {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    return undefined;
  };

  const getReviewsConfig = (ratingSnippet) => {
    const snippetShowReviewsIo = parseBoolean(ratingSnippet?.dataset?.showReviewsIo);
    const snippetShowReviewsPopup = parseBoolean(ratingSnippet?.dataset?.showReviewsPopup);
    const themeShowReviewsIo = parseBoolean(window.theme?.showReviewsIo);
    const themeShowReviewsPopup = parseBoolean(window.theme?.showReviewsPopup);

    return {
      showReviewsIo: snippetShowReviewsIo ?? themeShowReviewsIo ?? Boolean(ratingSnippet),
      showReviewsPopup: snippetShowReviewsPopup ?? themeShowReviewsPopup ?? false,
    };
  };

  const isReviewsIoScrollEnabled = (ratingSnippet) => {
    const config = getReviewsConfig(ratingSnippet);
    return config.showReviewsIo === true && config.showReviewsPopup === false;
  };

  const scrollElementIntoView = (target, delay = 0) => {
    if (!target) {
      return false;
    }

    window.setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, delay);

    return true;
  };

  const scrollToTargetWhenAvailable = (getTarget, delay = 0, timeout = TARGET_RETRY_TIMEOUT) => {
    const target = getTarget();

    if (scrollElementIntoView(target, delay)) {
      return true;
    }

    const startedAt = Date.now();
    const interval = window.setInterval(() => {
      const retryTarget = getTarget();

      if (scrollElementIntoView(retryTarget)) {
        window.clearInterval(interval);
        return;
      }

      if (Date.now() - startedAt >= timeout) {
        window.clearInterval(interval);
      }
    }, TARGET_RETRY_INTERVAL);

    return true;
  };

  const getRatingSnippetScrollTarget = () => {
    const reviewsIoWidget = document.querySelector(REVIEWS_IO_WIDGET_SELECTOR);

    if (reviewsIoWidget) {
      const target = reviewsIoWidget.closest('section.shopify-section, .shopify-section, .shopify-app-block') || reviewsIoWidget;
      return target;
    }

    const fallbackTarget = document.querySelector(PDP_REVIEWS_SELECTOR);
    return fallbackTarget;
  };

  const scrollToRatingSnippetReviews = (delay = 0) => {
    return scrollToTargetWhenAvailable(getRatingSnippetScrollTarget, delay);
  };

  const scrollToPdpReviewsContainer = (delay = 0) => {
    return scrollToTargetWhenAvailable(() => document.querySelector(PDP_REVIEWS_SELECTOR), delay);
  };

  document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('scrollTo') === 'reviews') {
      scrollToPdpReviewsContainer(SCROLL_DELAY);
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      const ratingSnippet = event.target.closest(RATING_SNIPPET_SELECTOR);

      if (!ratingSnippet) return;

      if (!isReviewsIoScrollEnabled(ratingSnippet)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToRatingSnippetReviews();
    },
    true
  );
})();
